/* eslint-disable no-return-assign */
import React from 'react';
import PropTypes from 'prop-types';
import styled from '@emotion/styled';

import Carousel from '../../molecules/product-carousel';
import ProductCard from '../../tissues/product-card/algolia';
import Typography from '../../atoms/typography';

const CarouselWrapper = styled.section`
  margin: 6.4rem 0;
  min-height: 10rem;
  position: relative;
  text-align: center;

  & + & {
    margin-top: 10rem;
  }
`;

const CarouselTitle = styled(Typography)`
  color: ${(props) => props.theme.color.bluePrimary};
  margin-bottom: ${(props) => props.theme.modularScale.twentyFour};

  @media (min-width: ${(props) => props.theme.breakpoint.medium}) {
    margin-bottom: 1rem;
  }
`;

const ProductCardCarousel = (props) => {
  const wrapAround = props.isInfinite && props.products?.results ? props.products.results.length > 5 : props.isInfinite;

  const carouselSettings = {
    prevNextButtons: props.products.length > 1,
    pageDots: false,
    cellAlign: 'left',
    wrapAround
  };

  return props.products?.length > 0 ? (
    <CarouselWrapper>
      <CarouselTitle element="h1" like="heading-7" data-test-id="carousel-title">
        {props.title}
      </CarouselTitle>
      <Carousel
        type="product-card"
        options={carouselSettings}
        loop={wrapAround}
        disableImagesLoaded
        reloadOnUpdate
        hasUpToFiveProducts={props.products.length > 1 && props.products.length < 6}>
        {props.products.map((product, i) => (
          <ProductCard
            taxonProducts={props.taxonProducts}
            key={`${props.id}-${product?.variants?.[0]?.maisonette_sku ?? product?.title}`}
            product={product}
            showQuickShop={false}
            showWishlist
            module={props.id}
            index={i + 1}
          />
        ))}
      </Carousel>
    </CarouselWrapper>
  ) : null;
};

ProductCardCarousel.defaultProps = {
  isInfinite: false,
  taxonProducts: true
};

ProductCardCarousel.propTypes = {
  products: PropTypes.array.isRequired,
  title: PropTypes.string.isRequired,
  id: PropTypes.string.isRequired,
  isInfinite: PropTypes.bool,
  taxonProducts: PropTypes.bool
};

export default ProductCardCarousel;
